// Sentry in der Kunden-App erkennbar machen (Launch-Check A21, 08.10.2026).
//
// Der Web-Sentry aus main.tsx läuft im App-Bundle mit. Ohne Markierung sind App-Fehler nicht von
// Website-Fehlern zu unterscheiden. Hier:
//   Tag platform      ios | android | web
//   Tag app_build     Store-Version + Build, z. B. „1.0 (2)“
//   Tag capgo_bundle  eingespieltes Live-Update oder „builtin“
//   release           charlies-app@<version>+<build>[-ota.<bundle>]  (nur in der App; Web bleibt wie bisher)
// Native Abstürze (Swift/Kotlin, Widget) erfasst das NICHT; dafür bräuchte es @sentry/capacitor als
// natives Plugin (eigener Store-Build), siehe Folgepunkt im PR.

import { getAppInfo, getPlatform, type AppInfo } from "@/lib/platform";

/** Release-Name für Sentry (rein, testbar). Sentry erlaubt keine Schrägstriche und Leerzeichen. */
export function appRelease(info: AppInfo): string | null {
  if (!info.version) return null;
  const clean = (v: string) => v.replace(/[^0-9A-Za-z._-]/g, "");
  let r = `charlies-app@${clean(info.version)}`;
  if (info.build) r += `+${clean(info.build)}`;
  if (info.bundle) r += `-ota.${clean(info.bundle)}`;
  return r.slice(0, 200);
}

let release: string | null = null;

/** Release der App, sobald gelesen (sonst null). Für beforeSend in main.tsx. */
export function sentryAppRelease(): string | null {
  return release;
}

/**
 * Tags setzen. Im Web sofort platform=web, in der App zusätzlich Version und Bundle,
 * sobald die native Bridge geantwortet hat. Wirft nie.
 */
export function sentryAppMarkieren(setTag: (key: string, value: string) => void): void {
  try {
    const platform = getPlatform();
    setTag("platform", platform);
    if (platform === "web") return;
    setTag("app", "kunden-app");
    void getAppInfo().then((info) => {
      if (!info) return;
      release = appRelease(info);
      if (info.version) setTag("app_build", `${info.version}${info.build ? ` (${info.build})` : ""}`);
      setTag("capgo_bundle", info.bundle ?? "builtin");
      if (release) setTag("app_release", release);
    }).catch(() => { /* Markierung ist Komfort, nie ein Fehler */ });
  } catch { /* still */ }
}
